import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'VatDeadline',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.4612 9.95801C19.0917 9.95982 20.6549 10.6088 21.8079 11.7617C22.9608 12.9146 23.6098 14.4779 23.6116 16.1084C23.6116 17.3248 23.2502 18.514 22.5745 19.5254C21.8987 20.5366 20.9383 21.3246 19.8147 21.79C18.6909 22.2555 17.454 22.3779 16.261 22.1406C15.0681 21.9033 13.9726 21.3171 13.1125 20.457C12.2525 19.597 11.6663 18.5015 11.429 17.3086C11.1917 16.1156 11.3141 14.8786 11.7795 13.7549C12.245 12.6313 13.033 11.6709 14.0442 10.9951C15.0556 10.3193 16.2448 9.95801 17.4612 9.95801ZM19.2405 11.8125C18.3908 11.4606 17.4559 11.3684 16.554 11.5479C15.652 11.7273 14.8234 12.17 14.1731 12.8203C13.5228 13.4706 13.0801 14.2992 12.9006 15.2012C12.7212 16.1031 12.8134 17.038 13.1653 17.8877C13.5172 18.7374 14.1135 19.4637 14.8782 19.9746C15.6428 20.4855 16.5416 20.7588 17.4612 20.7588L17.6917 20.752C18.8405 20.6937 19.9301 20.2118 20.7473 19.3945C21.619 18.5228 22.1101 17.3412 22.1116 16.1084C22.1116 15.1888 21.8382 14.29 21.3274 13.5254C20.8164 12.7607 20.0902 12.1644 19.2405 11.8125ZM17.4612 12.3584C17.6601 12.3584 17.8508 12.4375 17.9915 12.5781C18.1321 12.7188 18.2112 12.9095 18.2112 13.1084V15.6748L19.3948 16.3584C19.4801 16.4076 19.5555 16.4736 19.6155 16.5518C19.6754 16.6299 19.7189 16.7194 19.7444 16.8145C19.7699 16.9096 19.7767 17.0088 19.7639 17.1064C19.7511 17.2041 19.7194 17.2985 19.6702 17.3838C19.6209 17.4691 19.555 17.5436 19.4768 17.6035C19.3986 17.6635 19.3093 17.7079 19.2141 17.7334C19.119 17.7588 19.0197 17.7648 18.9221 17.752C18.8245 17.7391 18.7301 17.7075 18.6448 17.6582L17.0862 16.7578C16.9722 16.692 16.8776 16.5974 16.8118 16.4834C16.7459 16.3694 16.7112 16.2401 16.7112 16.1084V13.1084C16.7112 12.9095 16.7903 12.7188 16.9309 12.5781C17.0716 12.4375 17.2623 12.3584 17.4612 12.3584Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.3"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.2842 9.87146H9.73132V3.2306C9.73132 2.66139 9.35185 2.28191 8.78263 2.28191C4.03916 2.28191 0.244385 6.07668 0.244385 10.8202C0.244385 15.5636 4.03916 19.3584 8.78263 19.3584C9.20163 19.3584 9.61322 19.3288 10.0155 19.2715C9.76304 18.6811 9.57882 18.0545 9.47269 17.4017C5.9644 17.8121 2.69963 15.2876 2.23664 11.7688C1.66743 8.16381 4.2289 4.74851 7.83394 4.27417V10.8202C7.83394 11.3894 8.21341 11.7688 8.78263 11.7688H10.6182C11.072 11.0524 11.6351 10.4121 12.2842 9.87146ZM11.6287 1.33322C11.6287 0.763999 12.0082 0.384521 12.5774 0.384521C16.2773 0.384521 19.2183 3.32547 19.2183 7.02538C19.2183 7.59459 18.8388 7.97407 18.2696 7.97407H12.5774C12.0082 7.97407 11.6287 7.59459 11.6287 7.02538V1.33322ZM13.5261 2.37678V6.07668H17.226C16.8465 4.1793 15.4235 2.75626 13.5261 2.37678Z",
      fill: "currentColor"
    }, null, -1)
  ]), 2))
}
}

})